import React, {ComponentType} from 'react'
import {AbilityContextProvider} from '@modifi/plugin-authorization'
import {clientConfig} from '@modifi/client-config'
import {abilityFactory} from '../constants/permissions'

const withAbilityProvider = <P extends {}>(
  WrappedComponent: ComponentType<P>
): ComponentType<P> => {
  const ability = abilityFactory()

  ability.on('updated', ({target}) => {
    if (target.cannot('access-service', 'charon')) {
      // check where to redirect the user to

      if (target.can('access-service', 'matrix') && clientConfig.get('service_hub')) {
        // matrix is allowed, lets redirect the user
        requestAnimationFrame(() => {
          window.location.replace(clientConfig.get('service_hub') as string)
        })
      } else if (target.can('access-service', 'treseus') && clientConfig.get('service_billing')) {
        requestAnimationFrame(() => {
          window.location.replace(clientConfig.get('service_billing') as string)
        })
      } else if (target.can('access-service', 'argus') && clientConfig.get('service_shipments')) {
        requestAnimationFrame(() => {
          window.location.replace(clientConfig.get('service_shipments') as string)
        })
      }
    }
  })

  const ScopedComponent: React.FC<P> = props => (
    <AbilityContextProvider ability={ability}>
      <WrappedComponent {...props} />
    </AbilityContextProvider>
  )

  return React.memo(ScopedComponent)
}

export default withAbilityProvider
